import React, { useState } from "react";
import AddEditPaymentMethod from "./AddEditPaymentMethod";
import PaymentMethodsList from "./PaymentMethodsList";
import { Elements, ElementsConsumer } from "@stripe/react-stripe-js";
import { stripePromise } from "../../Payment/Payment";

const PaymentMethod = () => {
  const [addEditPaymentMethod, setAddEditPaymentMethod] = useState({
    isVisible: false,
    isEdit: false,
    data: null,
  });

  const onAddEditClose = () => {
    setAddEditPaymentMethod({
      isVisible: false,
      isEdit: false,
      data: null,
    });
  };

  return addEditPaymentMethod.isVisible ? (
    <Elements stripe={stripePromise} options={{ mode: "setup", currency: "usd" }}>
      <ElementsConsumer>
        {({ stripe, elements }) => (
          <AddEditPaymentMethod
            isEdit={addEditPaymentMethod.isEdit}
            editData={addEditPaymentMethod.data}
            onClose={onAddEditClose}
            stripe={stripe}
            elements={elements}
          />
        )}
      </ElementsConsumer>
    </Elements>
  ) : (
    <PaymentMethodsList setAddEditPaymentMethod={setAddEditPaymentMethod} />
  );
};

export default PaymentMethod;
